// components/lists/PharmacyList.jsx
import React from 'react';
import PharmacyCard from '../cards/PharmacyCard';

const PharmacyList = ({ 
  pharmacies, 
  loading, 
  viewMode, 
  showDistance,
  onPharmacyClick,
  onCallPharmacy 
}) => {
  if (loading) {
    return (
      <div className={`grid gap-6 ${
        viewMode === 'list' 
          ? 'grid-cols-1' 
          : 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3'
      }`}>
        {[1, 2, 3, 4, 5, 6].map((n) => (
          <div key={n} className="bg-white rounded-lg shadow overflow-hidden animate-pulse">
            <div className="h-48 bg-gray-200" />
            <div className="p-4 space-y-3">
              <div className="h-6 bg-gray-200 rounded w-3/4" />
              <div className="h-4 bg-gray-200 rounded w-1/2" />
              <div className="h-4 bg-gray-200 rounded w-full" />
              <div className="flex gap-2">
                <div className="h-8 bg-gray-200 rounded flex-1" />
                <div className="h-8 bg-gray-200 rounded w-16" />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (!pharmacies || pharmacies.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500">No pharmacies found</p>
      </div>
    );
  }

  return (
    <div className={`grid gap-6 ${
      viewMode === 'list' 
        ? 'grid-cols-1' 
        : 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3'
    }`}>
      {pharmacies.map((pharmacy) => (
        <PharmacyCard
          key={pharmacy._id}
          pharmacy={pharmacy}
          viewMode={viewMode}
          showDistance={showDistance}
          onPharmacyClick={onPharmacyClick}
          onCallPharmacy={onCallPharmacy}
        />
      ))}
    </div>
  );
};

export default PharmacyList;